module.exports = {
  GET_MERCHANT_OFFERS: "GET_MERCHANT_OFFERS",
  GET_OFFERS_DETAILS: "GET_OFFERS_DETAILS",
  CLEAR_OFFERS_DEATILS: "CLEAR_OFFERS_DEATILS",
  CLEAR_OFFERS: "CLEAR_OFFERS",
  GET_NEXT_PAGE: "GET_NEXT_PAGE",
  RESET_OFFERS: "RESET_OFFERS",
};
